import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { actions } from 'modules/debts';
import { actions as modalActions } from 'modules/modal';

import DebtEditable from './DebtEditable';

const validateInput = (type, value) => {
  const validators = {
    name: (name = '') => name.replace(/[^\w\d\s!@#$%^&*+'"/\\()-.,[\]]/gi, ''),
    current: (num = '') => num.replace(/[^\d.]/gi, ''),
    starting: (num = '') => num.replace(/[^\d.]/gi, ''),
    interest: (num = '') => num.replace(/[^\d.]/gi, ''),
  };

  const validator = validators[type] ? validators[type] : v => v;
  return validator(value);
};

class DebtEditableContainer extends PureComponent {
  state = {
    editing: this.props.details.isNew,
    order: this.props.index + 1,
    ...this.props.details,
  };

  onBalanceAction = (transactionType, details) => {
    const { onInterest, onPayment, showModal } = this.props;
    showModal('amount', {
      details,
      transactionType,
      onClose: amt => {
        if (transactionType === 'payment') {
          onPayment(details, amt);
        } else {
          onInterest(details, amt);
        }
      },
    });
  };

  onCancel = item => {
    if (item.isNew) {
      this.props.onRemove(item);
    } else {
      this.setState(state => ({
        editing: false,
        ...this.props.details,
      }));
    }
  };

  onEdit = () => {
    this.setState(state => ({ editing: true }));
  };

  onChange = ({ name, value }) => {
    this.setState(state => ({
      [name]: validateInput(name, value),
    }));
  };

  onSave = item => {
    this.props.onSave(item);
    this.setState(state => ({ editing: false }));
  };

  onRemove = item => {
    this.props.showModal('confirm', {
      type: 'alert',
      title: `Delete "${item.name}"`,
      message: `Are you sure you want to delete "${item.name}"?`,
      closeText: `Yes, Delete`,
      cancelText: `No, Nevermind`,
      onClose: () => this.props.onRemove(item),
    });
  };

  onInterest = (item, amt) => {
    this.props.onInterest(item, amt);
  };

  onPayment = (item, amt) => {
    this.props.onPayment(item, amt);
  };

  componentWillReceiveProps(nextProps) {
    this.setState(state => ({
      editing: nextProps.details.isNew,
      ...nextProps.details,
    }));
  }

  render() {
    const { editing, ...details } = this.state;

    return (
      <DebtEditable
        {...this.props}
        details={details}
        editing={editing}
        onBalanceAction={this.onBalanceAction}
        onCancel={this.onCancel}
        onChange={this.onChange}
        onEdit={this.onEdit}
        onRemove={this.onRemove}
        onSave={this.onSave}
      />
    );
  }
}

export default connect(null, {
  onInterest: actions.addInterest,
  onPayment: actions.addPayment,
  onRemove: actions.deleteDebt,
  onSave: actions.saveDebt,
  showModal: modalActions.showModal,
})(DebtEditableContainer);



// WEBPACK FOOTER //
// ./src/components/DebtEditable/DebtEditable.container.js